import { render, staticRenderFns } from "./sendSms.vue?vue&type=template&id=bf914ce2&scoped=true&"
import script from "./sendSms.vue?vue&type=script&lang=js&"
export * from "./sendSms.vue?vue&type=script&lang=js&"
import style0 from "./sendSms.vue?vue&type=style&index=0&id=bf914ce2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf914ce2",
  null
  
)

export default component.exports